import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect, useRef } from "react";
import "../B2chashing/b2chashing.css";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";
import swal from "sweetalert";
import Axios from "axios";

const FlipkartPO = () => {
  const [barcode, setBarcode] = useState("");
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const [Dataa, setDataa] = useState([]);
  const [totalScanned, setTotalScanned] = useState(0);
  const [loading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("method1");
  const barcodeInputRef = useRef(null);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        setDataa(response.data);
      }
    );
  }, []);


  const addBarcode = async (newBarcode) => {
    const isBarcodeMatched = Dataa.some((ite) =>
      ite.barcodeData?.includes(newBarcode)
    );

    if (isBarcodeMatched) {
      if (!scannedBarcodes.includes(newBarcode)) {
        const updatedBarcodes = [...scannedBarcodes, newBarcode];
        setScannedBarcodes(updatedBarcodes);
        setTotalScanned(updatedBarcodes.length);
        alertify.success("Barcode Scan Successfully", 3);

        const dataToSend = {
          barcodeData: [newBarcode], 
          count: 1,
        };

        const endpoints = {
          method1: `${INVENTORY_API_BASE_URL}/flipkartB2C`,
          method2: `${INVENTORY_API_BASE_URL}/AmazonB2C`,
          method3: `${INVENTORY_API_BASE_URL}/PinnacleB2C`,
          method4: `${INVENTORY_API_BASE_URL}/EmployeeB2C`,
          method5: `${INVENTORY_API_BASE_URL}/ScrapB2C`,
          method6: `${INVENTORY_API_BASE_URL}/SnapdealB2C`,
        };

        const selectedURL = endpoints[selectedMethod];

        try {
          await Axios.post(selectedURL, dataToSend);

          await Axios.delete(
            `${INVENTORY_API_BASE_URL}/putawayOutbound`,
            {
              data: { barcodeData: [newBarcode] },
            }
          );

        } catch (error) {
          alertify.error("Error saving barcode");
          console.error("Submit error:", error);
        }
      } else {
        alertify.error("Barcode already scanned", 3);
      }
    } else {
      alertify.error("Scan Correct Barcode", 3);
    }
  };

  const uppercaseBarcode = barcode;
  const handleManualBarcodeEntry = () => {
    if (barcode.trim() !== "") {
      addBarcode(uppercaseBarcode);
      setBarcode("");
      barcodeInputRef.current.focus();
    }
  };

  useEffect(() => {
    const handleBarcodeScan = (event) => {
      if (event.key === "Enter") {
        addBarcode(uppercaseBarcode);
        setBarcode("");
      }
    };

    const handleDocumentClick = (event) => {
      const clickedElement = event.target;
      if (
        clickedElement !== barcodeInputRef.current &&
        !clickedElement.closest(".B2C") &&
        !clickedElement.closest(".flipkart") &&
        !clickedElement.closest(".btn.btn-primary")
      ) {
        barcodeInputRef.current.focus();
      }
    };

    window.addEventListener("keydown", handleBarcodeScan);
    document.addEventListener("click", handleDocumentClick);

    return () => {
      window.removeEventListener("keydown", handleBarcodeScan);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [barcode]);

  return (
    <main className="bechashing-container b2c-page">
      <div className="b2c-workspace">
        <header className="b2c-page-header">
          <div className="b2c-title-block">
            <span className="b2c-eyebrow">INVENTORY / OUTBOUND</span>
            <h1>B2C Outbound</h1>
            <p>Send scanned stock to the selected sales channel.</p>
          </div>

          <div className="b2c-channel-picker">
            <label htmlFor="flipkart-po-channel">Sales channel</label>
            <select
              id="flipkart-po-channel"
              value={selectedMethod}
              className="B2C b2c-channel"
              onChange={(e) => setSelectedMethod(e.target.value)}
            >
              <option value="method1">Flipkart B2C</option>
              <option value="method2">Amazon B2C</option>
              <option value="method3">Pinnacle B2C</option>
              <option value="method4">Youtube Influencer</option>
              <option value="method5">Scrap</option>
              <option value="method6">Snapdeal B2C</option>
            </select>
          </div>
        </header>

        <div className="b2c-dashboard-grid">
          <section className="b2c-scan-panel" aria-labelledby="flipkart-po-scan-title">
            <div className="b2c-panel-heading">
              <div>
                <span className="b2c-section-label">SCAN STATION</span>
                <h2 id="flipkart-po-scan-title">Scan a barcode</h2>
                <p>Scan a code and press Enter to process it automatically.</p>
              </div>
              <span className="b2c-autosave-badge">
                <span aria-hidden="true" />
                Auto-save on
              </span>
            </div>

            <label className="b2c-input-label" htmlFor="flipkart-po-barcode">
              Barcode or product code
            </label>
            <div className="b2c-input-wrap">
              <svg
                className="b2c-input-icon"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path d="M4 5v14M7 5v14M10 5v14M14 5v14M17 5v14M20 5v14" />
              </svg>
              <input
                id="flipkart-po-barcode"
                className="b2csearch"
                type="text"
                ref={barcodeInputRef}
                value={barcode}
                aria-label="Scan or enter barcode"
                placeholder="Scan or enter barcode"
                autoComplete="off"
                onChange={(e) => setBarcode(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <p className="b2c-input-hint">
              Press Enter or use Add manually to submit a barcode.
            </p>
            <button
              type="button"
              className="btn btn-primary flipkart b2c-submit-button"
              onClick={handleManualBarcodeEntry}
            >
              Add manually
              <span aria-hidden="true">↵</span>
            </button>

            {loading && (
              <div className="b2c-processing-state" role="status">
                <span className="b2c-spinner" aria-hidden="true" />
                Completing outbound…
              </div>
            )}
          </section>

          <aside className="b2c-total-panel" aria-label="Session scan total">
            <span className="b2c-total-kicker">SESSION TOTAL</span>
            <strong className="b2c-total-value">
              {totalScanned.toLocaleString()}
            </strong>
            <span className="b2c-total-caption">barcodes scanned</span>
            <div className="b2c-total-note">
              <span className="b2c-total-dot" aria-hidden="true" />
              Scans accepted this session
            </div>
          </aside>
        </div>

        <section className="b2c-recent-panel" aria-labelledby="flipkart-po-recent-title">
          <div className="b2c-recent-heading">
            <div>
              <span className="b2c-section-label">ACTIVITY</span>
              <h2 id="flipkart-po-recent-title">Recent scans</h2>
            </div>
            <span className="b2c-recent-count">
              {scannedBarcodes.length.toLocaleString()} total
            </span>
          </div>

          {scannedBarcodes.length > 0 ? (
            <ul className="b2c-recent-list">
              {scannedBarcodes
                .slice(-6)
                .reverse()
                .map((code, index) => (
                  <li key={[code, index].join("-")}>
                    <span className="b2c-recent-code" title={code}>
                      {code}
                    </span>
                    <span className="b2c-scan-label">Scanned</span>
                  </li>
                ))}
            </ul>
          ) : (
            <div className="b2c-recent-empty">
              <span className="b2c-empty-icon" aria-hidden="true">
                —
              </span>
              <p>Recent barcode scans will appear here.</p>
            </div>
          )}
        </section>
      </div>
    </main>
  );
};
export default FlipkartPO;
